import { TaskService } from '@weave/schema-gen-ts/dist/schemas/task-center/v1/task_service.pb';
import { bindHTTP } from '@frontend/schema';

/**
 * @deprecated
 */
export const TaskCenterService = bindHTTP(TaskService);

export const DEFAULT_TASK_LIMIT = 20;
export const DEFAULT_TASK_LIMIT_V2 = 20;
export const DEFAULT_TASK_LIMIT_WIDGETS = 20;

/**
 * @deprecated
 */
export const TASK_BY_ID_QUERY_KEY = 'task-by-id';
